/* =========================================================================
   Upgreens: Kauf-Abschnitt — Umschalten der Variante
   (sections/ug-kaufen.liquid)

   Beim Wechsel der Farbe muessen vier Dinge mitwandern:
     1. die Varianten-ID im versteckten Feld  (sonst landet die falsche
        Variante im Warenkorb — der stille Fehler, der am meisten kostet)
     2. der Preis
     3. das Bild, falls die Variante ein eigenes hat
     4. der Knopf, wenn eine Variante ausverkauft ist

   WARUM NICHT MOTTOS `variant-radios`:
   Das Element haengt an der Markup-Struktur der Produktseite und laedt bei
   jedem Wechsel die halbe Sektion vom Server nach. Fuer einen Kaufblock mit
   einer Handvoll Varianten ist das unverhaeltnismaessig — die Daten stehen
   bereits als JSON in der Seite.

   Das Hinzufuegen selbst macht Mottos `<product-form>`. Hier wird nur die
   Auswahl gepflegt.
   ========================================================================= */
(function () {
  'use strict';

  function bloecke() {
    return document.querySelectorAll('[data-ug-kaufen]');
  }

  function varianten(block) {
    var sektion = block.closest('.shopify-section');
    if (!sektion) return null;
    var quelle = sektion.querySelector('[data-ug-kaufen-varianten]');
    if (!quelle) return null;
    try {
      return JSON.parse(quelle.textContent);
    } catch (e) {
      return null;
    }
  }

  function gewaehlteOptionen(block) {
    var felder = block.querySelectorAll('[data-ug-wert]:checked');
    var werte = [];
    felder.forEach(function (f) {
      var feldsatz = f.closest('[data-ug-option]');
      var i = feldsatz ? parseInt(feldsatz.dataset.ugOption, 10) : werte.length;
      werte[i] = f.value;
    });
    return werte;
  }

  function passendeVariante(liste, werte) {
    for (var i = 0; i < liste.length; i++) {
      var v = liste[i];
      var passt = true;
      for (var k = 0; k < werte.length; k++) {
        if (werte[k] !== undefined && v.optionen[k] !== werte[k]) {
          passt = false;
          break;
        }
      }
      if (passt) return v;
    }
    return null;
  }

  function bildTauschen(block, url) {
    var bild = block.querySelector('[data-ug-kaufen-bild]');
    if (!bild || !url || bild.src === url) return;
    // Erst ausblenden, dann tauschen: ohne das blitzt beim Wechsel kurz
    // das halb geladene neue Bild auf.
    bild.classList.add('ug-wechselt');
    var neu = new Image();
    neu.onload = function () {
      bild.src = url;
      bild.removeAttribute('srcset');
      bild.classList.remove('ug-wechselt');
    };
    neu.onerror = function () {
      bild.classList.remove('ug-wechselt');
    };
    neu.src = url;
  }

  function aktualisieren(block) {
    var liste = varianten(block);
    if (!liste) return;

    var werte = gewaehlteOptionen(block);
    var v = passendeVariante(liste, werte);

    // Beschriftung der Option mitfuehren ("Farbe — Pfeffer")
    block.querySelectorAll('[data-ug-option]').forEach(function (fs) {
      var i = parseInt(fs.dataset.ugOption, 10);
      var anzeige = fs.querySelector('[data-ug-option-wert]');
      if (anzeige && werte[i] !== undefined) anzeige.textContent = werte[i];
    });

    var feld = block.querySelector('[data-ug-varianten-id]');
    var knopf = block.querySelector('[data-ug-knopf]');
    var text = block.querySelector('[data-ug-knopf-text]');
    var preis = block.querySelector('[data-ug-preis]');
    var alt = block.querySelector('[data-ug-preis-alt]');

    if (!v) {
      // Kombination gibt es nicht — Kauf sperren statt etwas Falsches
      // in den Warenkorb zu lassen.
      if (feld) feld.disabled = true;
      if (knopf) knopf.disabled = true;
      if (text && window.variantStrings) text.textContent = window.variantStrings.unavailable;
      return;
    }

    if (feld) {
      feld.value = v.id;
      feld.disabled = !v.verfuegbar;
    }

    if (knopf) knopf.disabled = !v.verfuegbar;

    if (text && window.variantStrings) {
      text.textContent = v.verfuegbar
        ? knopf.dataset.ugBeschriftung || text.dataset.ugStandard || text.textContent
        : window.variantStrings.soldOut;
    }

    if (preis) preis.innerHTML = v.preis;

    if (alt) {
      if (v.alt) {
        alt.innerHTML = v.alt;
        alt.removeAttribute('hidden');
      } else {
        alt.setAttribute('hidden', '');
      }
    }

    bildTauschen(block, v.bild);
  }

  function start() {
    bloecke().forEach(function (block) {
      if (block.dataset.ugBereit) return;
      block.dataset.ugBereit = '1';

      // Ausgangsbeschriftung merken, damit sie nach "Ausverkauft" wieder
      // zurueckkommt.
      var text = block.querySelector('[data-ug-knopf-text]');
      if (text) text.dataset.ugStandard = text.textContent.trim();

      block.addEventListener('change', function (e) {
        if (!e.target.matches('[data-ug-wert]')) return;
        aktualisieren(block);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Der Theme-Editor baut Sektionen neu auf
  document.addEventListener('shopify:section:load', start);
})();
